export const useInvoicesTypes = false;
export const useManufacturingBonds = true;
export const useSalesStatement = true;
export const multipleWarehouses  = false;
export const useWarehousesPermissions  = false;
export const separationOfInvoices = false;
export const isMangeUnitAndRegionAndPatchAndLot = false
export const useSaleInvoiceReceipts = true
export const useSaleInvoiceExpenses = true
export const useBuyInvoicePayments = true
export const useBuyInvoiceExpenses = true
export const useMaterialStatusDeliver = false
export const useConfigInvoicesAccount = false
export const useUnPostingPermission = false
export const useInvoiceCategories = false
export const useZeroInvoiceEntiresPrice = false
export const usePeerBoxAccountsForAccountStatement = false
export const userChildrenMainAccountStatement = true
export const useChildrenMaterialStatement = true
export const canCreateInvoiceWithoutDocNo = false
export const useZeroPriceInMaterialJournals = false
export const groupingStatementInvoiceEntries = false
export const useManufacturerCode = false
export const useTotalInvoicesStatementPage = false
export const useInvoiceCashType = false
export const saveInvoiceWithLastEntry = true
export const useChangeCurrency = true
export const showCategoryColumn = false
export const useMaterialsJournalType = false;
export const useOrderBuyPage = false;
export const useWarehouseMaterialsCopy = false;
export const useBondAuditLogs = false;
export const useBondNotes = true;
export const useAdvancedMaterialDetails = false;
export const usePinnedAccounts = false;
export const useInvoicesAuditLogs = false;
export const useSalesStatementInvoicesStatusFilter = false;
export const useCopyMaterial = false;
export const usePriceOfferPage = false;
export const useFavoritesNavigationMenu = false;
export const advanceAccountHasAccessToMaterialsTree = false;
export const invoiceCategoryMaterialsOnly = false;
